import type {GuideState} from "@khan/guide-types";

export const DefaultGuideState: GuideState = Object.freeze({
    activityPersona: null,
    bufferResponse: true,
    cooldownStatus: {
        hasCooldown: false,
        cooldownType: "None" as const,
        expiresAt: null,
        teacherKaid: null,
        teacherName: null,
    },
    contentURLPath: null,
    contextualLinks: [],
    conversation: [],
    conversationEntries: [],
    annotations: [],
    dynamicBot: null,
    essaySessionId: null,
    hasAcknowledgedGuide: false,
    initialized: false,
    initializationPromise: null,
    isHighTraffic: false,
    isLoading: false,
    isOffline: false,
    menusDisabled: false,
    modelOverride: null,
    navigation: {id: "00000000-0000-0000-000-000000000000", path: ""},
    open: false,
    ratedInteractions: new Map(),
    remainingQuota: null,
    retryTimeoutSeconds: 0,
    selectedBotName: null,
    stopId: null,
    swagId: "default",
    images: [],
    userAsStudent: false,
    userHasToggledPersona: false,
    temperatureOverride: null,
    threadId: null,
});
